<template>
  <Col :span="span" class="m-b-8 f-14">
    <span>{{title}}</span>
    <span>{{value}}<slot></slot></span>
  </Col>
</template>
<script>
  export default {
    name: "Cell",
    data() {
      return {};
    },
    computed: {
    },
    props: {
      title: [String, Number],
      value: [String, Number, Array],
      span: {type: String, default: '8'},
    }
  };
</script>
